import Seo from '../seo/Seo';
import { PAGE_SEO, getSchemasForPage } from '../../content/seo';

export default function PageSeo({ pageKey, titleOverride, descriptionOverride }) {
  const page = PAGE_SEO[pageKey];
  if (!page) return null;

  const isHome = pageKey === 'home';
  const includeOrg = isHome;

  return (
    <Seo
      title={titleOverride || page.title}
      description={descriptionOverride || page.description}
      keywords={page.keywords}
      path={page.path}
      noindex={page.noindex}
      schemas={getSchemasForPage(pageKey, {
        includeOrg,
        includeLocalBusiness: isHome,
      })}
    />
  );
}
